module.exports = __webpack_public_path__ + "img/Save.2f54d9a8.svg";